import { motion } from 'framer-motion';
import { cn } from '@/utils/cn';

interface ReadingSettingsMenuProps {
    bgColor: 'white' | 'sepia' | 'dark';
    onBgColorChange: (color: 'white' | 'sepia' | 'dark') => void;
    onClose: () => void;
}

const ReadingSettingsMenu = ({
    bgColor,
    onBgColorChange,
    onClose
}: ReadingSettingsMenuProps) => {

    // Background color options
    const colorOptions: { value: 'white' | 'sepia' | 'dark'; label: string; bgClass: string; borderClass: string }[] = [
        { value: 'dark', label: 'تیره', bgClass: 'bg-gray-900', borderClass: 'border-gray-700' },
        { value: 'sepia', label: 'کرم', bgClass: 'bg-[#f5f0e1]', borderClass: 'border-[#d4c4a8]' },
        { value: 'white', label: 'روشن', bgClass: 'bg-white', borderClass: 'border-gray-300' }
    ];

    return (
        <>
            {/* Backdrop overlay - click to close */}
            <motion.div
                initial={{ opacity: 0 }}
                animate={{ opacity: 1 }}
                className="fixed inset-0 z-[69]"
                onClick={onClose}
            />
            <motion.div
                initial={{ opacity: 0, y: 100 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{
                    type: 'spring',
                    stiffness: 400,
                    damping: 30
                }}
                className="fixed bottom-[72px] left-6 right-6 z-[70] md:left-1/2 md:right-auto md:-translate-x-1/2 md:w-[85%] md:max-w-sm"
                onClick={(e) => e.stopPropagation()}
            >
                <div
                    className={cn(
                        'rounded-2xl shadow-2xl border backdrop-blur-xl',
                        'px-4 pt-2 pb-3',
                        bgColor === 'dark'
                            ? 'bg-gray-800/95 border-gray-700'
                            : bgColor === 'sepia'
                                ? 'bg-[#f4ecd8]/95 border-[#d4c4a8]'
                                : 'bg-gray-50/95 border-gray-200'
                    )}
                >
                    <div className="flex items-center justify-center py-1" dir="rtl">
                        {/* Background Color Section */}
                        <div className="flex flex-col items-center">
                            <h3
                                className={cn(
                                    'text-[11px] font-medium mb-2 font-persian opacity-80',
                                    bgColor === 'dark' ? 'text-gray-200' : 'text-gray-700'
                                )}
                            >
                                رنگ پس‌زمینه
                            </h3>
                            <div className="flex items-center gap-3">
                                {colorOptions.map((option) => (
                                    <button
                                        key={option.value}
                                        onClick={() => onBgColorChange(option.value)}
                                        className={cn(
                                            'w-10 h-10 rounded-full border-2 transition-all duration-200 flex-shrink-0',
                                            option.bgClass,
                                            bgColor === option.value
                                                ? 'border-[#655adb] scale-110 shadow-lg shadow-[#655adb]/30'
                                                : option.borderClass + ' hover:scale-105 opacity-70'
                                        )}
                                        aria-label={`تغییر به ${option.label}`}
                                    />
                                ))}
                            </div>
                        </div>
                    </div>
                </div>
            </motion.div>
        </>
    );
};

export default ReadingSettingsMenu;

